import React from "react";
import { Box, Typography } from "@mui/material";

export const TEMPLATE_WIDTH = 3508;
export const TEMPLATE_HEIGHT = 2480;

export const config = {
  width: TEMPLATE_WIDTH,
  height: TEMPLATE_HEIGHT,
  regions: [
    { id: "main_look", x: 0.05, y: 0.19, width: 0.5, height: 0.68 },
    { id: "option_1", x: 0.59, y: 0.19, width: 0.17, height: 0.3 },
    { id: "option_2", x: 0.78, y: 0.19, width: 0.17, height: 0.3 },
    { id: "option_3", x: 0.59, y: 0.54, width: 0.17, height: 0.3 },
    { id: "option_4", x: 0.78, y: 0.54, width: 0.17, height: 0.3 },
  ],
  textFields: [
    {
      id: "marca",
      x: 0.05,
      y: 0.04,
      width: 0.26,
      height: 0.05,
      fontSize: 50,
      fontWeight: "bold",
      color: "#ffffff",
      backgroundColor: "#151515",
    },
  ],
};

const tile = {
  border: "1px solid #cfcfcf",
  borderRadius: "8px",
  background:
    "linear-gradient(145deg, rgba(251,251,251,1) 0%, rgba(236,236,236,1) 100%)",
  overflow: "hidden",
  position: "relative",
};

function PlantillaColorOptionsPro({ marca = "MARCA", className }) {
  return (
    <Box
      className={className}
      sx={{
        width: "100%",
        height: "100%",
        aspectRatio: `${TEMPLATE_WIDTH}/${TEMPLATE_HEIGHT}`,
        bgcolor: "#f6f6f6",
        border: "1px solid #d7d7d7",
        borderRadius: "10px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Typography
        sx={{
          position: "absolute",
          left: "5%",
          top: "3%",
          fontSize: ".17rem",
          color: "#222",
          fontWeight: 700,
          letterSpacing: 0.3,
        }}
      >
        COLOR OPTIONS
      </Typography>

      <Box
        sx={{
          position: "absolute",
          left: "5%",
          top: "6.5%",
          width: "26%",
          height: "5%",
          bgcolor: "#151515",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          px: 0.9,
          borderRadius: "4px",
        }}
      >
        <Typography sx={{ fontSize: ".25rem", fontWeight: 700 }}>
          {marca}
        </Typography>
      </Box>

      <Box sx={{ position: "absolute", left: "5%", top: "19%", width: "50%", height: "68%", ...tile }}>
        <Box sx={{ position: "absolute", inset: "2.5%", border: "1px dashed #9f9f9f", borderRadius: "6px" }} />
      </Box>

      {[
        { left: "59%", top: "19%", label: "V1" },
        { left: "78%", top: "19%", label: "V2" },
        { left: "59%", top: "54%", label: "V3" },
        { left: "78%", top: "54%", label: "V4" },
      ].map((s) => (
        <Box key={s.label} sx={{ position: "absolute", left: s.left, top: s.top, width: "17%", height: "30%", ...tile }}>
          <Typography sx={{ position: "absolute", top: 3, right: 4, fontSize: ".13rem", color: "#303030", fontWeight: 700 }}>
            {s.label}
          </Typography>
          <Box sx={{ position: "absolute", inset: "8%", border: "1px dashed #a1a1a1", borderRadius: "5px" }} />
        </Box>
      ))}
    </Box>
  );
}

export default PlantillaColorOptionsPro;
